export const UserMessages = {
  CREATE_ROOM: "CREATE_ROOM",
  JOIN_ROOM: "JOIN_ROOM",
  CHAT_MESSAGE: "CHAT_MESSAGE",
  START_GAME: "START_GAME",
  PLAYER_FOLDED: "PLAYER_FOLDED",
  PLAYER_CALLED: "PLAYER_CALLED",
  PLAYER_RAISED: "PLAYER_RAISED",
  EXIT_GAME: "EXIT_GAME",
  LEAVE_ROOM: "LEAVE_ROOM",
  PLAYER_STAND: "PLAYER_STAND",
  PLAYER_SIT: "PLAYER_SIT",
  CHAT_MESSAGE_GAME: "CHAT_MESSAGE_GAME",
  GET_ONLINE_FRIENDS: "GET_ONLINE_FRIENDS",
  SEND_FRIEND_CHAT: "SEND_FRIEND_CHAT",
  GET_FRIEND_CHAT_UNREAD_COUNTS: "GET_FRIEND_CHAT_UNREAD_COUNTS",
  MARK_FRIEND_CHAT_SEEN: "MARK_FRIEND_CHAT_SEEN",
  REVEAL_CARD: "REVEAL_CARD",
  REVEAL_REMAINING_TABLE_CARDS: "REVEAL_REMAINING_TABLE_CARDS",
  JOIN_AS_PLAYER: "JOIN_AS_PLAYER",
  REQUEST_GAME_STATE: "REQUEST_GAME_STATE",
} as const;

